import Navigation from '../app/components/NavigationSPA';

export default function MoveSmartProbePage() {
  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-gray-50 p-4">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Move SmartProbe</h1>
          <div className="bg-white rounded-lg shadow p-6">
            <p className="text-gray-600">Move SmartProbe page - To be ported</p>
          </div>
        </div>
      </div>
    </>
  );
}
